<template>
  <div class="home-page">
    <a-carousel arrows>
      <template #prevArrow>
        <div class="custom-slick-arrow custom-prev">
          <left-circle-outlined />
        </div>
      </template>
      <template #nextArrow>
        <div class="custom-slick-arrow custom-next">
          <right-circle-outlined />
        </div>
      </template>
      <div>
        <div class="slide" :style="{ backgroundImage: `url(${homeBg1})` }">
          <div class="slide-content">
            <p class="date">21-24<sup>th</sup> August 2025</p>
            <h1 class="title">
              14<sup>th</sup> Indonesian Echocardiography Meeting (INAecho) in conjunction with
              24<sup>th</sup> MCVU
            </h1>
            <p class="description">
              Join us in the biggest (and only) echocardiography annual event, The 14th Indonesian
              Echocardiography Meeting (INAecho) in conjunction with The 24th MCVU, 21 - 24 August
              2025, Grand Mercure Mirama Hotel Malang
            </p>
            <div class="buttons">
              <a-button type="primary" class="register-btn">REGISTER NOW</a-button>
              <a-button class="events-btn" @click="goToEvents">VIEW OTHER EVENTS</a-button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="slide" :style="{ backgroundImage: `url(${homeBg2})` }">
          <div class="slide-content">
            <p class="date">1–4<sup>th</sup> October 2025</p>
            <h1 class="title">
              ASMIHA: Annual Scientific Meeting of Indonesian Heart Association
            </h1>
            <p class="description">
              Participate in the most comprehensive cardiovascular meeting in Indonesia and connect
              with medical personnels to advance cardiovascular service. ASMIHA 2025 will be held at
              1–4 October 2025 in Intercontinental Hotel, Jakarta.
            </p>
            <div class="buttons">
              <a-button type="primary" class="register-btn">REGISTER NOW</a-button>
              <a-button class="events-btn" @click="goToEvents">VIEW OTHER EVENTS</a-button>
            </div>
          </div>
        </div>
      </div>
    </a-carousel>

    <!-- SECTION CARDS -->
    <div class="cards-section">
      <div class="cards-container">
        <!-- Training Card -->
        <div class="card-item" style="background: #EB1D35;">
          <div class="card-image">
            <img :src="card1" alt="ACLS Training" />
          </div>
          <div class="card-content">
            <span class="card-category">TRAINING BY PERKI</span>
            <div class="divider"></div>
            <h3 class="card-title">ACLS Training</h3>
            <p class="card-description">
              Upgrade your skill by participating in PERKI's ACLS training. Save more lives.
            </p>
            <a-button class="card-button">FIND OUT MORE</a-button>
          </div>
        </div>

        <!-- Learning Management System Card -->
        <div class="card-item" style="background: #E10F28;">
          <div class="card-image">
            <img :src="card2" alt="Learning Management System" />
          </div>
          <div class="card-content">
            <span class="card-category">LEARNING MANAGEMENT SYSTEM</span>
            <div class="divider"></div>
            <h3 class="card-title">Level Up Your Learning</h3>
            <p class="card-description">
              Learn more from courses and programs by PERKI in fields of cardiovascular science.
            </p>
            <a-button class="card-button">FIND OUT MORE</a-button>
          </div>
        </div>

        <!-- Publications Card -->
        <div class="card-item" style="background: #D10B22;">
          <div class="card-image">
            <img :src="card3" alt="Publications" />
          </div>
          <div class="card-content">
            <span class="card-category">PUBLICATIONS</span>
            <div class="divider"></div>
            <h3 class="card-title">Guidelines & Documents</h3>
            <p class="card-description">
              Find guidelines, statements, and publications relevant to cardiology and healthcare.
            </p>
            <a-button class="card-button">FIND OUT MORE</a-button>
          </div>
        </div>

        <!-- Contact Info Card -->
        <div class="card-item contact-card" style="background: #282828;">
          <div class="card-content">
            <!-- Contact Info -->
            <div class="contact-item">
              <div class="contact-icon">
                <img :src="icon1" alt="Contact Icon" />
              </div>
              <div class="contact-details">
                <span class="card-category">CONTACT INFO</span>
                <p class="contact-text">+62 21 568 1149</p>
                <ul class="contact-list">
                  <li>Ext 101 (inaheart secretariat)</li>
                  <li>Ext 106 (collegium inaheart)</li>
                  <li>Ext 108 (web-support)</li>
                </ul>
                <p class="contact-email">secretariat@inaheart.org</p>
              </div>
            </div>

            <!-- Location Info -->
            <div class="contact-item">
              <div class="contact-icon">
                <img :src="icon2" alt="Location Icon" />
              </div>
              <div class="contact-details">
                <span class="card-category">OUR LOCATION</span>
                <p class="contact-text">
                  Heart House, Jl. Katalia Raya No. 5 4, Kota Jakarta Barat
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ABOUT US SECTION -->
    <div class="about-section">
      <div class="about-container">
        <div class="about-image">
          <img :src="doctorSolo" alt="Indonesian Heart Association" />
        </div>
        <div class="about-content">
          <span class="section-category">ABOUT US</span>
          <div class="divider"></div>
          <h1 class="about-title">Indonesian Heart Association (PERKI)</h1>
          <p class="about-description">
            Perkumpulan Kardiologi Indonesia (PERKI) was founded on November 16, 1957, initiated by
            Dr. Gan Tjong Bing, and officially established on November 28, 1957, due to the
            increasing of interest in the study of cardiovascular diseases in the 1950s and the
            development of relationships between cardiovascular experts in Indonesia and abroad.
          </p>
          <a-button type="primary" class="learn-more-btn">LEARN MORE</a-button>
        </div>
      </div>
    </div>
    <!-- NEWS & ARTICLES SECTION -->
    <div class="news-section">
      <div class="section-header">
        <h2 class="section-title">News & Articles</h2>
        <a-button class="view-all-btn" @click="goToNewsArticles">
          VIEW ALL <right-outlined />
        </a-button>
      </div>
      <div class="news-container">
        <div
          v-for="item in newsArticles"
          :key="item.id"
          class="news-item"
          @click="viewNewsDetail(item.id)"
        >
          <div class="news-image">
            <img :src="item.image" :alt="item.title" />
          </div>
          <div class="news-content">
            <span class="news-date">{{ item.date }}</span>
            <h3 class="news-title">{{ item.title }}</h3>
            <p class="news-excerpt">{{ item.excerpt }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- CHAPTERS SECTION -->
    <div class="chapters-section">
      <div class="section-header">
        <h2 class="section-title">Chapters</h2>
        <a-button class="view-all-btn" @click="goToChapters">
          VIEW ALL <right-outlined />
        </a-button>
      </div>
      <div class="chapters-grid">
        <div v-for="chapter in chapters" :key="chapter.id" class="chapter-card">
          <div class="card-icon">
            <img :src="locationIcon" alt="Location Pin" />
          </div>
          <h3 class="chapter-title">{{ chapter.name }}</h3>
          <p class="card-text" v-if="chapter.address">
            <strong>Sekretariat:</strong> {{ chapter.address }}
          </p>
          <p class="card-text" v-if="chapter.contact">
            <strong>Contact:</strong> {{ chapter.contact }}
          </p>
          <p class="card-text" v-if="chapter.email"><strong>Email:</strong> {{ chapter.email }}</p>
        </div>
      </div>
    </div>
    <div class="section-header">
      <h2 class="section-title">Working Group</h2>
      <a-button class="view-all-btn" @click="goToWorkingGroup">
        VIEW ALL <right-outlined />
      </a-button>
    </div>
    <div class="wg-grid">
      <div class="wg-card">
        <div class="card-header">
          <img :src="iconValveRheumatic" alt="Valve & Rheumatic Heart Disease Icon" />
          <h2 class="card-title">Valve & Rheumatic Heart Disease</h2>
        </div>
        <div class="card-body">
          <p class="card-detail"><strong>Chairman:</strong> Dr. Renan Sukmawan, Sp.JP(K), FIHA</p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://inavalverhd.inaheart.org/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconInterventional" alt="Interventional Cardiology Icon" />
          <h2 class="card-title">Interventional Cardiology</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Dafsah Arifa Djalan, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://www.isic.or.id/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconElectrophysiology" alt="Electrophysiology & Pacing Icon" />
          <h2 class="card-title">Electrophysiology & Pacing</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Dicky Armein Hanafy, PhD, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Gedung Utama Lantai 2, Ruang Poliklinik,
            Jakarta
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> ina.hrs.perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://inahrs.or.id/" target="blank" class="visit-website-btn">VISIT WEBSITE</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LeftCircleOutlined, RightCircleOutlined, RightOutlined } from '@ant-design/icons-vue'
import homeBg1 from '@/assets/img/home-bg-1.png'
import homeBg2 from '@/assets/img/home-bg-2.png'
import card1 from '@/assets/img/home/card-1.png'
import card2 from '@/assets/img/home/card-2.png'
import card3 from '@/assets/img/home/card-3.png'
import icon1 from '@/assets/img/home/icon-1.png'
import icon2 from '@/assets/img/home/icon-2.png'
import doctorSolo from '@/assets/img/home/doctor-solo.png'
import locationIcon from '@/assets/img/about-us/who-we-are/section-1.png'
import iconValveRheumatic from '@/assets/img/about-us/working-group/ina-valve.png'
import iconInterventional from '@/assets/img/about-us/working-group/isic.png'
import iconElectrophysiology from '@/assets/img/about-us/working-group/ina-hrs.png'
export default {
  name: 'Home',
  components: {
    LeftCircleOutlined,
    RightCircleOutlined,
    RightOutlined,
  },
  data() {
    return {
      iconElectrophysiology,
      iconInterventional,
      iconValveRheumatic,
      locationIcon,
      homeBg1,
      homeBg2,
      card1,
      card2,
      card3,
      icon1,
      icon2,
      doctorSolo,
      newsArticles: [
        {
          id: 1,
          title: 'New Guidelines for Cardiovascular Health Released',
          excerpt:
            'PERKI announces updated guidelines for cardiovascular disease prevention and management in Indonesia.',
          date: 'November 10, 2025',
          image: require('@/assets/img/home/card-1.png'),
        },
        {
          id: 2,
          title: 'ASMIHA 2025 Registration Now Open',
          excerpt:
            'Join the largest cardiovascular conference in Indonesia. Early bird registration available until December.',
          date: 'November 8, 2025',
          image: require('@/assets/img/home/card-2.png'),
        },
        {
          id: 3,
          title: 'Breakthrough in Heart Failure Treatment',
          excerpt:
            'Indonesian cardiologists contribute to international research on novel heart failure management strategies.',
          date: 'November 5, 2025',
          image: require('@/assets/img/home/card-3.png'),
        },
      ],
      chapters: [
        {
          id: 1,
          name: 'PERKI Aceh',
          address: 'RSUD dr. Zainoel Abidin, Jl. T. Daud Beureueh No. 108, Banda Aceh',
          contact: '08116891008',
          email: 'perkiaceh@gmail.com',
        },
        {
          id: 2,
          name: 'PERKI Sumatera Utara',
          address:
            'RSUP H. Adam Malik, Jl. Bunga Lau No. 17, Kemenangan Tani, Medan Tuntungan, Medan 20136',
          contact: '061-8361721',
          email: 'perkisumut@gmail.com',
        },
        {
          id: 3,
          name: 'PERKI Sumatera Barat',
          address: 'RSUP Dr. M. Djamil, Jl. Perintis Kemerdekaan, Padang 25127',
          contact: '0751-32372',
          email: 'perkisumbar@gmail.com',
        },
      ],
      workingGroups: [
        {
          id: 1,
          name: 'Interventional Cardiology',
          description:
            'Focused on advancing minimally invasive cardiac procedures and catheter-based interventions.',
          image: require('@/assets/img/home/card-1.png'),
        },
        {
          id: 2,
          name: 'Heart Failure',
          description:
            'Dedicated to improving diagnosis, treatment, and management of heart failure patients.',
          image: require('@/assets/img/home/card-2.png'),
        },
        {
          id: 3,
          name: 'Echocardiography',
          description:
            'Advancing cardiac imaging techniques and standards for echocardiographic practice.',
          image: require('@/assets/img/home/card-3.png'),
        },
      ],
    }
  },
  methods: {
    goToEvents() {
      this.$router.push('/guidelines/events')
    },
    goToNewsArticles() {
      this.$router.push('/guidelines/news')
    },
    goToChapters() {
      this.$router.push('/about/chapters')
    },

    goToWorkingGroup() {
      this.$router.push('/about/working-group')
    },
    viewNewsDetail(id) {
      this.$router.push(`/guidelines/content/${id}`)
    },
    viewChapterDetail(id) {
      this.$router.push(`/about/chapters/${id}`)
    },
    viewGroupDetail(id) {
      this.$router.push(`/about/working-group/${id}`)
    },
  },
}
</script>

<style scoped>
.chapter-card {
  background-color: #f8f9fa; /* Warna abu-abu muda seperti di gambar */
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}
/* Existing Carousel Styles */
.ant-carousel :deep(.slick-list),
.ant-carousel :deep(.slick-track),
.ant-carousel :deep(.slick-slide) {
  height: 90vh !important;
}

.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 40px !important;
  height: 40px !important;
  font-size: 28px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.9;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50%;
  z-index: 10;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.ant-carousel :deep(.slick-arrow.custom-prev) {
  left: 20px !important;
}

.ant-carousel :deep(.slick-arrow.custom-next) {
  right: 20px !important;
}

.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 1;
}

.slide {
  position: relative;
  width: 100%;
  height: 90vh;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 16px;
  overflow: hidden;
  /* margin: 0 20px; */
}

.slide-content {
  position: relative;
  z-index: 2;
  max-width: 45%;
  padding-left: 6%;
  color: #fff;
}

.date {
  font-size: 1.5rem;
  color: #444444;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.date::after {
  content: '';
  display: block;
  width: 50px;
  height: 3px;
  background-color: #e10f28;
  margin-top: 0.8rem;
}

.title {
  font-size: 4.5rem;
  font-weight: 700;
  color: #e10f28;
  margin: 0.5rem 0 1.5rem 0;
  line-height: 1.1;
}

.description {
  font-size: 1.2rem;
  color: #444444;
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 95%;
}

.buttons {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
}

.register-btn {
  background-color: #e10f28 !important;
  border-color: #e10f28 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.65rem 2rem !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  height: auto !important;
}

.register-btn:hover {
  background-color: #333 !important;
  border-color: #333 !important;
}

.events-btn {
  background-color: #333 !important;
  border-color: #333 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.65rem 2rem !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  height: auto !important;
}

.events-btn:hover {
  background-color: #1a1a1a !important;
  border-color: #1a1a1a !important;
}

/* Cards Section */
.cards-section {
  padding: 4rem 2rem;
  background-color: #fff;
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* gap: 2rem; */
  max-width: 1200px;
  margin: 0 auto;
}

.card-item {
  /* border-radius: 8px; */
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 550px;
  display: flex;
  flex-direction: column;
}

.card-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.card-category {
  font-size: 0.8rem;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.divider {
  width: 40px;
  height: 2px;
  background-color: #000000;
  margin: 0.8rem 0 1rem 0;
}

.card-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #ffffff;

  margin-bottom: 1rem;
  line-height: 1.3;
}

.card-description {
  color: #ffffff;

  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.card-button {
  border: 1px solid #000000 !important;
  color: #000000 !important;
  /* background: transparent !important; */
  border-radius: 50px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
  font-size: 12px;
  margin-top: auto;
  margin-bottom: 20px;
}

.card-button:hover {
  background-color: #000000 !important;
  border-color: #666 !important;
  color: #fff !important;
}

/* Contact Card Specific Styles */
.contact-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 2rem;
}

.contact-card .card-category {
  color: #ffffff;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-icon {
  flex-shrink: 0;
  width: 40px;
  margin-right: 1rem;
}

.contact-icon img {
  width: 100%;
  height: auto;
}

.contact-details {
  flex: 1;
}

.contact-text {
  font-weight: 600;
  color: #ffffff;
  margin: 0.5rem 0;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0;
}

.contact-list li {
  color: #ffffff;
  font-size: 0.9rem;
  margin-bottom: 0.2rem;
}

.contact-email {
  color: #e10f28;
  font-weight: 600;
  margin: 0.5rem 0 0 0;
}

/* News & Articles Section */
.news-section {
  padding: 4rem 2rem;
  background-color: #f8f9fa;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto 3rem auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #e10f28;
  margin: 0;
}

.view-all-btn {
  background-color: #e10f28 !important;
  border-color: #e10f28 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.65rem 1.5rem !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  height: auto !important;
  display: flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
}

.view-all-btn:hover {
  background-color: #333 !important;
  border-color: #333 !important;
}

.news-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.news-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.news-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.news-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-content {
  padding: 1.5rem;
}

.news-date {
  font-size: 0.85rem;
  color: #999;
  font-weight: 500;
}

.news-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
  margin: 0.5rem 0;
  line-height: 1.4;
}

.news-excerpt {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0;
}

/* Chapters Section */
.chapters-section {
  padding: 4rem 2rem;
  background-color: #fff;
}

.chapters-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.chapter-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.chapter-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.chapter-icon {
  width: 80px;
  height: 80px;
  background-color: #e10f28;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem auto;
  font-size: 2.5rem;
  color: #fff;
}

.chapter-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 1rem 0;
}

.chapter-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.chapter-btn {
  background-color: #e10f28 !important;
  border-color: #e10f28 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.65rem 1.5rem !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  height: auto !important;
}

.chapter-btn:hover {
  background-color: #333 !important;
  border-color: #333 !important;
}

/* Working Group Section */
.working-group-section {
  padding: 4rem 2rem;
  background-color: #f8f9fa;
}

.working-group-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.working-group-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.working-group-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.group-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.group-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.group-content {
  padding: 1.5rem;
}

.group-name {
  font-size: 1.3rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 1rem 0;
}

.group-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.group-btn {
  background-color: #e10f28 !important;
  border-color: #e10f28 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.65rem 1.5rem !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  height: auto !important;
}

.group-btn:hover {
  background-color: #333 !important;
  border-color: #333 !important;
}

/* About Section */
.about-section {
  padding: 4rem 2rem;
  /* background-color: #f8f9fa; */
}

.about-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  max-width: 1200px;
  margin: 0 auto;
  align-items: center;
}

.about-image {
  width: 100%;
  /* height: 400px; */
  /* border-radius: 8px; */
  overflow: hidden;
}

.about-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: scale(0.8);
}

.about-content {
  padding: 0 1rem;
}

.section-category {
  font-size: 0.9rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.about-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #e10f28;
  margin: 1rem 0 1.5rem 0;
  line-height: 1.2;
}

.about-description {
  color: #666;
  line-height: 1.7;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.learn-more-btn {
  background-color: #e10f28 !important;
  border-color: #e10f28 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.75rem 2rem !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  height: auto !important;
}

.learn-more-btn:hover {
  background-color: #333 !important;
  border-color: #333 !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .cards-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .news-container,
  .chapters-container,
  .working-group-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .about-container {
    gap: 2rem;
  }

  .about-title,
  .section-title {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .cards-container,
  .news-container,
  .chapters-container,
  .working-group-container {
    grid-template-columns: 1fr;
  }

  .section-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .about-container {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .about-image {
    height: 300px;
  }

  .slide-content {
    max-width: 90%;
    padding-left: 5%;
  }

  .title {
    font-size: 2.5rem;
  }

  .section-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .cards-section,
  .about-section,
  .news-section,
  .chapters-section,
  .working-group-section {
    padding: 2rem 1rem;
  }

  .title {
    font-size: 2rem;
  }

  .about-title,
  .section-title {
    font-size: 1.5rem;
  }
}

.card-icon {
  margin-bottom: 1rem;
}

.card-icon img {
  width: 45px; /* Sesuaikan ukuran icon */
  height: 45px;
  /* Asumsi icon Anda berwarna merah */
}

.chapters-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.chapter-card {
  background-color: #f8f9fa; /* Warna abu-abu muda seperti di gambar */
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.card-icon {
  margin-bottom: 1rem;
}

.card-icon img {
  width: 45px; /* Sesuaikan ukuran icon */
  height: 45px;
  /* Asumsi icon Anda berwarna merah */
}

.chapter-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #e10f28; /* Warna merah PERKI */
  margin-bottom: 1.5rem;
  min-height: 40px; /* Memberi tinggi minimum agar sejajar */
}

.card-text {
  font-size: 0.9rem;
  color: #555;
  text-align: left;
  margin-bottom: 0.5rem;
  line-height: 1.5;
}

.card-text strong {
  color: #000;
  font-weight: 700;
  display: block; /* Membuat label (Sekretariat, Contact) di baris sendiri */
}

.wg-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.wg-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}

.wg-card:hover {
  transform: translateY(-5px);
}

.visit-website-btn {
  display: inline-block;
  background-color: #e10f28;
  color: #fff;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.visit-website-btn:hover {
  background-color: #d62828;
}
.card-header {
  background-color: #ffffff;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.card-header img {
  /* width: 70px;
  height: 70px;
  margin-bottom: 1rem; */
  object-fit: contain;
}
</style>
